interface CardItem {
  title: string;
  tag: string;
  desc: string;
  imageUrl: string;
  imageAlt: string;
}

const cardItems: CardItem[] = [
  {
    title: '春节档票房大战复盘',
    tag: '行业观察',
    desc: '2025春节档总票房突破百亿，《封神2》《哪吒2》领跑，国产电影市场持续升温',
    imageUrl: 'https://readdy.ai/api/search-image?query=Crowded%20Chinese%20movie%20theater%20lobby%20during%20Spring%20Festival%20with%20red%20decorations%20and%20movie%20posters%2C%20festive%20atmosphere%2C%20warm%20golden%20and%20red%20lighting%2C%20lively%20crowd%2C%20professional%20documentary%20photography&width=600&height=340&seq=card-1-wuma&orientation=landscape',
    imageAlt: '春节档票房大战复盘',
  },
  {
    title: 'IMAX 与杜比影院对比',
    tag: '观影指南',
    desc: '大片该选IMAX还是杜比？从画质、音效到票价，全方位对比帮你做出最佳选择',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20luxury%20movie%20theater%20interior%20with%20premium%20seating%20and%20large%20screen%2C%20warm%20ambient%20lighting%2C%20state-of-the-art%20cinema%20technology%2C%20professional%20interior%20photography%2C%20elegant%20design&width=600&height=340&seq=card-2-wuma&orientation=landscape',
    imageAlt: 'IMAX与杜比影院对比指南',
  },
  {
    title: '那些被低估的国产佳片',
    tag: '片单推荐',
    desc: '豆瓣8分以上却票房平平，这五部国产电影值得被更多人看到，每一部都是诚意之作',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cozy%20home%20movie%20night%20setup%20with%20projector%20and%20warm%20lighting%2C%20film%20posters%20on%20wall%2C%20comfortable%20atmosphere%2C%20cinematic%20home%20theater%20vibe%2C%20soft%20warm%20tones%2C%20lifestyle%20photography&width=600&height=340&seq=card-3-wuma&orientation=landscape',
    imageAlt: '被低估的国产佳片推荐',
  },
  {
    title: '电影配乐大师作品赏析',
    tag: '深度影评',
    desc: '从汉斯·季默到久石让，那些让你起鸡皮疙瘩的电影配乐背后的创作故事',
    imageUrl: 'https://readdy.ai/api/search-image?query=Orchestra%20performing%20film%20score%20in%20a%20recording%20studio%2C%20warm%20golden%20lighting%2C%20musicians%20with%20instruments%2C%20cinematic%20composition%2C%20professional%20music%20photography%2C%20atmospheric%20and%20dramatic&width=600&height=340&seq=card-4-wuma&orientation=landscape',
    imageAlt: '电影配乐大师作品赏析',
  },
  {
    title: '2025下半年最值得期待',
    tag: '新片前瞻',
    desc: '下半年还有哪些重磅大片即将上映？科幻续作、动画神作、悬疑黑马全在这里了',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20slate%20composition%20with%20film%20clapperboard%20and%20coming%20soon%20posters%2C%20dramatic%20lighting%2C%20warm%20and%20exciting%20atmosphere%2C%20professional%20movie%20industry%20photography%2C%20anticipation%20mood&width=600&height=340&seq=card-5-wuma&orientation=landscape',
    imageAlt: '2025下半年最值得期待新片',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
              影讯快报
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              最新电影资讯与深度行业观察，让你比别人更懂电影
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {cardItems.slice(0, 3).map((item, idx) => (
              <div
                key={idx}
                className="group rounded-xl overflow-hidden bg-background-100 border border-background-200/70 transition-all duration-300 cursor-pointer"
              >
                <div className="h-44 overflow-hidden bg-background-200">
                  <img
                    src={item.imageUrl}
                    alt={item.imageAlt}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="p-4 md:p-5">
                  <span className="inline-block px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-2">
                    {item.tag}
                  </span>
                  <h3 className="text-base font-heading font-semibold text-foreground-900 mb-1.5 group-hover:text-primary-500 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
            {cardItems.slice(3).map((item, idx) => (
              <div
                key={idx + 3}
                className="group flex flex-col sm:flex-row rounded-xl overflow-hidden bg-background-100 border border-background-200/70 transition-all duration-300 cursor-pointer"
              >
                <div className="sm:w-2/5 h-40 sm:h-auto overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={item.imageUrl}
                    alt={item.imageAlt}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1 p-4 flex flex-col justify-center">
                  <span className="inline-block px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium w-fit mb-2">
                    {item.tag}
                  </span>
                  <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 mb-1 group-hover:text-primary-500 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}